import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FirmService {


  constructor(private http: HttpClient) { }

  getFirmDetailsByName(firmName: string): Observable<string> {
    const inputJson = { "firm_name": firmName };
    return this.http.post<string>(environment.apiUrl + `/public/get_firm_details_by_name`, inputJson);
  }

  getUserProfileResetPasswordByAzureuserId(userAzureId: string) {

    const inputJson = { "azure_userid": userAzureId };
    return this.http.post<string>(environment.apiUrl + `/public/get_user_profile_reset_password_by_azureuserid`, inputJson);
  }
}
